export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_Toyota_RAV4.3bf3f0ce.jpg";